// extracted by mini-css-extract-plugin
export default {"recos":"f5-z","productCardOverride":"g5-z","rowHasBadge":"h5-z"};